import { images } from '../constants';

const games = [
    {
        id: 1,
        image: images.gameBannerSUMO,
        logo: images.gameSumoRobot,
        title: 'SUMO Robot',
        content: 'The Sumo Robot competition is a thrilling one-on-one battle where robots try to push each other out of the ring, with participants grouped by age and robot specs.',
        paragraphs: [
            'The Sumo Robot competition is one of the most popular one-on-one challenges at the WRG. Much like traditional Japanese sumo wrestling, two robots attempt to push each other out of the ring to score points. ',
            'Participants are grouped by age and robot specifications to ensure a fair and enjoyable competition experience.'
        ],
        gallery: [
            images.gameGallerySUMO01,
            images.gameGallerySUMO02
        ],
        category: {
            intro: 'There are 3 sub categories:',
            list: [
                {
                    id: 1,
                    title: "Autonomous Sumo Robot Divisions",
                    divisions:[
                        { 
                            id: 1,
                            title: "BASIC Junior",
                            features: [
                                "Competitor age: 8 to 14 years",
                                "Robot size: within 25cm x 25cm",
                                "Robot weight: under 1.5 kg"
                            ]
                        },{ 
                            id: 2,
                            title: "Junior",
                            features: [
                                "Competitor age: 8 to 14 years",
                                "Robot size: within 20cm x 20cm",
                                "Robot weight: under 1.5 kg"
                            ]
                        },{ 
                            id: 3,
                            title: "Senior",
                            features: [
                                "Competitor age: 15 to 19 years",
                                "Robot size: within 20cm x 20cm",
                                "Robot weight: under 3 kg"
                            ]
                        },{ 
                            id: 4,
                            title: "STEM",
                            features: [
                                "Competitor age: 8 to 19 years",
                                "Robot size: within 25cm x 25cm",
                                "Robot weight: under 2.5 kg"
                            ]
                        },
                    ]
                },{
                    id: 2,
                    title: "Remote Control Sumo Robot Divisions",
                    divisions:[
                        { 
                            id: 0,
                            title: "Junior",
                            features: [
                                "Competitor age: 8 to 14 years",
                                "Robot size: within 25cm x 25cm",
                                "Robot weight: under 1.5 kg"
                            ]
                        },
                        { 
                            id: 1,
                            title: "BASIC Junior",
                            features: [
                                "Competitor age: 8 to 14 years",
                                "Robot size: within 25cm x 25cm",
                                "Robot weight: under 1.5 kg"
                            ]
                        },{ 
                            id: 3,
                            title: "Junior Advance",
                            features: [
                                "Competitor age: 8 to 14 years",
                                "Robot size: within 25cm x 25cm",
                                "Must Use V7RC App to remote control SUMO robot",
                                "Robot weight: under 1.5 kg",
                                "up to 4 drives motors. The brushless motor is not allowed."
                            ]
                        },{ 
                            id: 2,
                            title: "Senior",
                            features: [
                                "Competitor age: 15 to 19 years",
                                "Robot size: within 25cm x 25cm",
                                "Robot weight: under 3 kg"
                            ]
                        },{ 
                            id: 4,
                            title: "Senior Advance",
                            features: [
                                "Competitor age: 15 to 19 years",
                                "Robot size: within 25cm x 25cm",
                                "Must Use V7RC App to remote control SUMO robot",
                                "Robot weight: under 3 kg",
                                "Any kinds of motors and battery are allowed"
                            ]
                        },
                    ]
                },{
                    id: 3,
                    title: "Sumo Family Division",
                    divisions:[
                    //     { 
                    //         id: 1,
                    //         title: " BASIC Junior",
                    //         features: [
                    //             "Competitor age: 10 to 14 years",
                    //             "Robot size: within 25cm x 25cm",
                    //             "Robot weight: under 1.5 kg"
                    //         ]
                    //     },{ 
                    //         id: 2,
                    //         title: "Senior",
                    //         features: [
                    //             "Competitor age: 15 to 19 years",
                    //             "Robot size: within 25cm x 25cm"
                    //         ]
                    //     },
                     ]
                }
            ]
        },
        requirements: {
            intro: 'Each competition category includes detailed regulations regarding the robot\'s size and specifications. The rules also clearly outline participant violations and prohibited behaviors during the event. Please read the competition rules carefully before registering.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        arena: {
            intro: '(To be announced)?',
            list: [
                'Simple and fast online registration',
                'Secure payment options',
                'Instant confirmation and e-tickets',
                'Wide range of events to choose from',
                'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: '2025 WRG SUMO ROBOT AUTO',
                    url: '/files/gamerules/WRG2025-SumoRobotRule-EN.pdf'
                    
                },
                {
                    id: 2,
                    title: '2025 WRG SUMO ROBOT RC',
                    url: '/files/gamerules/WRG2025-SumoRobotRCRule-EN.pdf'
                    
                },
                {
                    id: 3,
                    title: '2025 WRG SUMO FAMILY',
                    url: '/files/gamerules/WRG2025-SumoFamilyRule-EN.pdf'
                    
                },
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        features: {
            intro: 'Why choose our event registration platform?',
            list: [
                'Simple and fast online registration',
                'Secure payment options',
                'Instant confirmation and e-tickets',
                'Wide range of events to choose from',
                'User-friendly interface for seamless booking'
            ]
        },
        process: {
            intro: 'How to register for an event:',
            list: [
                'Browse available events on our platform',
                'Select your desired event and ticket type',
                'Fill in your details and confirm your booking',
                'Make a secure payment',
                'Receive your e-ticket instantly via email'
            ]
        },
        faqs: [
            // {
            //     id: 1,
            //     heading: 'How do I register for an event?',
            //     content: 'You can register by selecting an event, choosing your ticket type, and completing the payment. You will receive a confirmation email with your e-ticket.'
            // },
            // {
            //     id: 2,
            //     heading: 'Can I purchase tickets for multiple events?',
            //     content: 'Yes, you can register for multiple events and manage your bookings from your account dashboard.'
            // },
            // {
            //     id: 3,
            //     heading: 'What payment methods do you accept?',
            //     content: 'We accept credit/debit cards, PayPal, and other secure online payment methods.'
            // },
            // {
            //     id: 4,
            //     heading: 'Can I cancel or transfer my ticket?',
            //     content: 'Ticket cancellation and transfer policies vary by event. Check the event details for specific terms before booking.'
            // }
        ]
    },
    {
        id: 2,
        image: images.gameBannerLine,
        logo: images.gameLineTracing,
        title: 'Line Tracing',
        content: 'Access a comprehensive schedule of sessions and events.',
        paragraphs: [
            'This is a personal robot competition that uses the simplest electronic and mechanical principles to trace lines without the need for programming.',
            'The design of the mechanism and the stability of the electronic circuits will determine whether your robot can perform faster than others, making it a challenging individual project.'
        ],
        gallery: [
            // images.service2Gallery1,
            // images.service2Gallery2
        ],
        requirements: {
            intro: 'Each competition category includes detailed regulations regarding the robot\'s size and specifications. The rules also clearly outline participant violations and prohibited behaviors during the event. Please read the competition rules carefully before registering.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: '2025 Beam Line Tracing Game',
                    url: '/files/gamerules/WRG2025-BEAMrobotRule-EN.pdf'
                    
                },
                {
                    id: 2,
                    title: '2025 Beam Battle Game',
                    url: '/files/gamerules/WRG2025-BeamBattleRule-EN.pdf'
                    
                }
            ]
        }
    },
    {
        id: 3,
        image: images.gameBannerProg,
        logo: images.gameProgrammable,
        title: 'Programmable Line Tracing Robot',
        content: 'Connect with fellow attendees through networking sessions.',
        paragraphs: [
            'By integrating sensors and MCU processing capabilities, competitors aim to build the fastest line-tracing robot and achieve impressive results.',
            'Each participant must gather track data through pre-race practice, which becomes a true test of programming skills and adaptability. Don’t miss out on this thrilling event—make sure to join!'
        ],
        gallery: [
            // images.service3Gallery1,
            // images.service3Gallery2
        ],
        requirements: {
            intro: 'Each competition category includes detailed regulations regarding the robot\'s size and specifications. The rules also clearly outline participant violations and prohibited behaviors during the event. Please read the competition rules carefully before registering.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: '2025 Program Line Tracing',
                    url: '/files/gamerules/WRG2025-ProgrammableLine-EN.pdf'
                    
                }
            ]
        }
    },
    {
        id: 4,
        image: images.gameBannerBallFight,
        logo: images.gameBallFighting,
        title: 'Ball Fighting Robot',
        content: '',
        paragraphs: [
            'This exciting game is simple: when time is up, the team with fewer balls on their side wins. Competitors must find ways to push balls into the opponent\'s field while preventing balls from entering their own. ',
            'Teams of up to 4 members can participate. The key to victory lies in both the flexibility of the robots and strong teamwork.'
        ],
        gallery: [
            // images.service3Gallery1,
            // images.service3Gallery2
        ],
        requirements: {
            intro: 'Each competition category includes detailed regulations regarding the robot\'s size and specifications. The rules also clearly outline participant violations and prohibited behaviors during the event. Please read the competition rules carefully before registering.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: '2025 Ball fighting - OPEN',
                    url: '/files/gamerules/WRG2025-BallFightingRule-EN.pdf'
                    
                }
            ]
        }
    },
    {
        id: 5,
        image: images.gameBannerSoccer,
        logo: images.gamesSoccer,
        title: 'Soccer Robots 4 x 4',
        content: '',
        paragraphs: [
            'Nothing is more thrilling in a team competition than the 4 vs 4 Football Robot match! This event not only tests the agility and control skills of each participant but also challenges the durability and mobility of every robot on the field.',
            'Each team must carefully design their robots in advance with specific offensive and defensive roles to gain the upper hand and score as many goals as possible. Don’t miss your chance to be part of this electrifying game—sign up now!'
        ],
        gallery: [
            // images.service5Gallery1,
            // images.service5Gallery2
        ],
        requirements: {
            intro: 'Each competition category includes detailed regulations regarding the robot\'s size and specifications. The rules also clearly outline participant violations and prohibited behaviors during the event. Please read the competition rules carefully before registering.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: '2025 Soccer Robots 4 x 4 - OPEN',
                    url: '/files/gamerules/WRG2025-Soccer4x4Rule-EN.pdf'
                    
                }
            ]
        }
    },
    {
        id: 5,
        image: images.gameBannerSoccer,
        logo: images.soccerW3,
        title: 'W3-Soccer Robot',
        content: '',
        paragraphs: [
            'The W3-Soccer Robot Competition is a three-team soccer-style robot match where participants control or program robots to score goals against opponents. The winner is determined by having the fewest Lost Goals (LG) at the end of the 3-minute match. The competition uses a league and knockout format, culminating in finals with awards for top teams.',
        ],
        gallery: [
            // images.service5Gallery1,
            // images.service5Gallery2
        ],
        category: {
            intro: 'There are 1 categories:',
            list: [
                {
                    id: 1,
                    title: "OPEN Category",
                    divisions:[
                        { 
                            id: 1,
                            title: "brief:",
                            features: [
                                "Team composition: Each team has 3 members (ages 8–99).",
                                "Participation rule: Each participant may join only one team.",
                                "Robot size: within 20cm x 20cm",
                                "Robot weight: under 1 kg"
                            ]
                        }
                    ]
                }
            ]
        },
        requirements: {
            intro: 'The competition field is about 2.4 by 2.4 meters with three small goals, and the ball is soft, no larger than 10 mm in diameter. Each robot must fit within 20 by 20 centimeters, weigh less than 1 kilogram including battery, and can move autonomously or by remote control. There are no limits on parts, and 3D printing or toy modifications are allowed, but robots must be durable and safe. Blades, sharp edges, scoops, gripping devices, or anything that could damage the field or throw non-game objects are strictly prohibited. Matches last three minutes, and every conceded goal counts as one Lost Goal (LG), with the lowest LG winning. Robots must stay active during play; if stopped or touched by players, they may be removed. Repairs are permitted only in the designated area with light tools, while the match time continues. Any insults, interference, or deliberate delays are violations that can lead to immediate penalties or disqualification, and if a mentor breaks the rules, all their teams are disqualified.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: '2025 W3 soccor - OPEN',
                    url: '/files/gamerules/WRG2025-W3-SoccerRule-EN.pdf'
                    
                }
            ]
        }
    },
    {
        id: 6,
        image: images.gameBannerOMG,
        logo: images.gameOMG,
        title: 'One Minute Game',
        content: 'Access presentations, and resources to enhance your learning.',
        paragraphs: [
            'The One Minute Robot Game is a fast-paced and highly competitive category that should not be underestimated. Each year, participants continue to surprise judges with creativity and outstanding performance.',
            'This is a programming-based, autonomous robot competition designed for individual players. '
        ],
        gallery: [
            // images.service6Gallery1,
            // images.service6Gallery2
        ],
        requirements: {
            intro: 'Each competition category includes detailed regulations regarding the robot\'s size and specifications. The rules also clearly outline participant violations and prohibited behaviors during the event. Please read the competition rules carefully before registering.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: '2025 OMG: Carry The Ball - Junior',
                    url: '/files/gamerules/WRG2025-OMG-CarryTheBall-EN.pdf'
                    
                },
                {
                    id: 2,
                    title: '2025 OMG: Drop The Box - Senior',
                    url: '/files/gamerules/WRG2025-OMG-DropTheBoxSeniorRule-EN.pdf'
                    
                },
                {
                    id: 3,
                    title: '2025 OMG: Hit The Ball - Senior',
                    url: '/files/gamerules/WRG2025-OMG-HitTheBallSeniorRule-EN.pdf'
                    
                },
                {
                    id: 4,
                    title: '2025 OMG: Move The Can - Juniior',
                    url: '/files/gamerules/WRG2025-OMG-MoveTheCanJuniorRule-EN.pdf'
                    
                },
                {
                    id: 5,
                    title: '2025 OMG: Shoot The Ball - Juniior',
                    url: '/files/gamerules/WRG2025-OMG-ShootTheBallJuniorRule-EN.pdf'
                    
                }
            ]
        }
    },
    {
        id: 7,
        image: images.gameBannerSecure,
        logo: images.gameSecureRobot,
        title: 'Rescue Mission Challenge Robot',
        content: 'Access presentations, and resources to enhance your learning.',
        paragraphs: [
            'This competition combines line-tracing and maze-solving capabilities with mission execution under time pressure, making it one of the most challenging events in WRG.',
            'Participants must design intelligent robots capable of navigating complex scenarios and completing tasks efficiently.',
            'This is an OPEN category, welcoming participants of all ages to take on the challenge.',
        ],
        gallery: [
            // images.service6Gallery1,
            // images.service6Gallery2
        ],
        requirements: {
            intro: 'Each competition category includes detailed regulations regarding the robot\'s size and specifications. The rules also clearly outline participant violations and prohibited behaviors during the event. Please read the competition rules carefully before registering.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: '2025 Secure Intelligent Robot (AI Feature) - OPEN ',
                    url: '/files/gamerules/WRG2025-NEW-RescueMissionRule-EN.pdf'
                    
                }
            ]
        }
    },
    {
        id: 8,
        image: images.gameBannerInno,
        logo: images.gameInnovativeRobots,
        title: 'Innovative Robot',
        content: 'Sub category: Innovative and Incredible Machine',
        paragraphs: [
            'The annual highlight of the WRG competition is the INNOVATIVE ROBOT category. INNOVATIVE ROBOT is divided into two subcategories: STEAM 10 - 19 and Incredible Machine. Each year, the STEAM 10 - 19 category follows a unique theme. This year\'s theme is AI Robotics, where participants are tasked with creating a robot equipped with AI computing capabilities.',
            'The Incredible Machine category, as always, emphasizes complexity and creativity. Participants must integrate more than four control boards, along with sensors and motors, to build a machine that can operate in a continuous, cyclical manner—so impressive that it truly feels "incredible." Most importantly, this is an OPEN category, welcoming participants of all ages to join the competition.'
        ],
        gallery: [
            // images.service6Gallery1,
            // images.service6Gallery2
        ],
        requirements: {
            intro: 'Each competition category includes detailed regulations regarding the robot\'s size and specifications. The rules also clearly outline participant violations and prohibited behaviors during the event. Please read the competition rules carefully before registering.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: '2025 Innovative AI Robot - Junior / Senior',
                    url: '/files/gamerules/WRG2025-InnovativeRule-EN.pdf'
                    
                },{
                    id: 2,
                    title: '2025 Incredible Machine - OPEN',
                    url: '/files/gamerules/WRG2025-IncredibleMachineRule-EN.pdf'
                    
                }
            ]
        }
    },
    {
        id: 9,
        image: images.gameBannerDroneSoccer,
        logo: images.DroneSocccer,
        title: 'Drone Soccer',
        content: 'Technology Ignites—Let the Battle Light Up the Sky!',
        paragraphs: [
            'The Drone Soccer Competition Rules follow the FAI F9A-B international standard and apply to the OPEN category (ages 8–99).',
            'Each team consists of three players, competing in a 6 m × 3 m × 3 m standard field.',
            'Each match lasts 3 minutes and uses a cumulative scoring system: the attacker earns 1 point per goal, and after all drones return to their own half, an additional 1 point may be scored; except in the finals, penalties result in a direct deduction of 1 point.',
            'The game uses dual-mode electronic scoring goals and LED identification lighting for fairness and visibility.',
            'The tournament adopts an elimination format, with winners advancing and the champion determined by total scores.',
            'Violations such as early takeoff, interference, or misconduct result in warnings, yellow cards, or red cards.',
            'All final interpretations rest with the organizers and referee committee.'
        ],
        gallery: [
            // images.service6Gallery1,
            // images.service6Gallery2
        ],
        requirements: {
            intro: 'Each competition category includes detailed regulations regarding the robot\'s size and specifications. The rules also clearly outline participant violations and prohibited behaviors during the event. Please read the competition rules carefully before registering.',
            list: [
                // 'Simple and fast online registration',
                // 'Secure payment options',
                // 'Instant confirmation and e-tickets',
                // 'Wide range of events to choose from',
                // 'User-friendly interface for seamless booking'
            ]
        },
        downloads: {
            intro: 'Game rule documents',
            list: [
                {
                    id: 1,
                    title: 'Drone Soccer Game Rule - OPEN',
                    url: '/files/gamerules/WRG2025-DroneSoccer-EN.pdf'
                    
                }
            ]
        }
    }
];

export default games;